import React from 'react'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import { ContextProvider } from './Component/Context'
import Home from './Component/Home'
import Contact from './Component/Contact'
import Quote from './Component/Quote'
import NotFound from './Component/NotFound'

function App() {

  return (
    <ContextProvider>
      <Router>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route path="/devis" component={Quote}/>
          <Route path="/contact" component={Contact}/>
          <Route  component={NotFound}/>
        </Switch>
      </Router>
    </ContextProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js